import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static values = {
    autoShow: Boolean,
    targetId: String
  }

  connect() {
    this.modal = new Modal(this.element)
    if (this.autoShowValue) { this.open() }
  }

  disconnect() {
    if (this.modal) {
      this.modal.dispose()
    }
  }

  open() {
    const modal = this.hasTargetIdValue ? document.getElementById(this.targetIdValue) : this.element
    const bootstrapModal = Modal.getOrCreateInstance(modal)
    bootstrapModal.show()
  }

  close() {
    if (this.modal) {
      this.modal.hide()
    }
  }
}
